<template>
  <div>
    <div class="text-center" style="margin-top: 150px">
      <img src="http://i.gtimg.cn/qqlive/images/20170712/logo_gold.svg" alt="">
    </div>
  </div>
</template>
<script>
export default {

}
</script>
